// extracted by mini-css-extract-plugin
export default {"line_table_link":"styles_line_table_link__+ueN+","navigate_table":"styles_navigate_table__tdGrx","search_block":"styles_search_block__udzNM","calendar":"styles_calendar__hlusg"};